import { render, staticRenderFns } from "./menuHeader.vue?vue&type=template&id=24882f09&scoped=true"
import script from "./menuHeader.vue?vue&type=script&lang=js"
export * from "./menuHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24882f09",
  null
  
)

export default component.exports